import { render } from "./qaLst.vue?vue&type=template&id=32bf5b5c&scoped=true"
import script from "./qaLst.vue?vue&type=script&lang=js"
export * from "./qaLst.vue?vue&type=script&lang=js"

import "./qaLst.vue?vue&type=style&index=0&id=32bf5b5c&scoped=true&lang=css"

import exportComponent from "F:\\2021年交接\\前端嘉俊交接\\项目\\新重本紫腾重构\\zbzt-website-pc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32bf5b5c"]])

export default __exports__